module.exports = __webpack_public_path__ + "static/media/usecase-card-2-icon.7a663b2e.svg";